import { formatDate } from '@/lib/locale'
import { formatPayrollMoney } from '@/features/payroll/format'

export type ReportResultTable = {
  title?: string
  rows: Record<string, unknown>[]
  columns?: { key: string; header: string }[]
}

const DATE_KEYS = new Set([
  'week_ending', 'due_date', 'scheduled_for', 'settled_at', 'released_at',
  'created_at', 'period_start', 'period_end', 'hire_date', 'pay_date',
])

export function humanize(key: string): string {
  const base = key.replace(/_minor_units$/, '').replace(/_/g, ' ').trim()
  return base.charAt(0).toUpperCase() + base.slice(1)
}

export function formatCell(key: string, value: unknown): string {
  if (value === null || value === undefined || value === '') return '-'
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  const k = key.toLowerCase()
  if (k.endsWith('_minor_units')) return formatPayrollMoney(String(value))
  if (k.endsWith('_date') || k.endsWith('_at') || DATE_KEYS.has(k)) return formatDate(String(value))
  return String(value)
}

export function deriveColumns(table: ReportResultTable): { key: string; header: string }[] {
  if (table.columns && table.columns.length > 0) return table.columns
  if (table.rows.length === 0) return []
  return Object.keys(table.rows[0])
    .filter((key) => key !== 'id' && !key.endsWith('_id'))
    .map((key) => ({ key, header: humanize(key) }))
}
